import { Route, Routes } from '@angular/router';
import { AppletNavMapComponent } from '../../components/component/applet-nav-map/applet-nav-map.component';
import { MainComponent } from '../main/main.component';
import { BlankComponent } from '../pages/blank.component';
import { ErrorComponent } from '../pages/error.component';
import { IFrameComponent } from '../pages/iframe.component';
import { LoginComponent } from '../pages/login.component';

/**
 * 根路由默认设置
 */
export const APP_ROOT_DEFAULT_ROUTS: Routes = [
    { path: '', component: BlankComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'home', component: BlankComponent },
    { path: 'dashboard', component: AppletNavMapComponent, data:{ mainFoolterHidden:false } },
    { path: 'iframe', component: IFrameComponent, data:{ hiddenScrolling:true } },
    { path: '500', component: ErrorComponent, data:{ errorCode:500, dark: true } },
    { path: '404', component: ErrorComponent, data:{ errorCode:404, dark: true } },
    { path: '403', component: ErrorComponent, data:{ errorCode:403, dark: true } },
    { path: '**', redirectTo: '404' },
];

/**
 * 单个应用的路由设置
 */
export const APPLET_DEFAULT_ROUTS: Routes = [
    { path: '', component: BlankComponent, pathMatch: 'full' },  // app的默认首页
    { path: 'dashboard', component: AppletNavMapComponent, data:{ mainFoolterHidden:false } },
    { path: 'iframe', component: IFrameComponent, data:{ mainFoolterHidden:true, hiddenScrolling:true } },
    { path: '500', component: ErrorComponent, data:{ errorCode:500, mainFoolterHidden:true } },
    { path: '404', component: ErrorComponent, data:{ errorCode:404, mainFoolterHidden:true } },
    { path: '403', component: ErrorComponent, data:{ errorCode:403, mainFoolterHidden:true } },
    { path: '**', redirectTo: '404' },
];

// 示例
// const routes: Routes = [
//     { path: 'apps', component: MainComponent, children:[
//         { path: ':app-id', component: BlankComponent, children: [
//             // --------------------------------------------------------------------------
//             // 此处添加自己的应用

//             { path: 'my-app', component: AppletNavMapComponent, pathMatch: 'full' },
//             { path: 'my-app', loadChildren: () => { return MyAppletModule; } },

//             // --------------------------------------------------------------------------
//             ...APPLET_DEFAULT_ROUTS
//         ] }
//     ] },
//   ...APP_ROOT_DEFAULT_ROUTS,
// ];